import clsx from 'clsx';
import { Handle, Position } from '@xyflow/react';
import type { ReactNode } from 'react';
import type { NodeState } from '@/lib/types';
import { StatusDot } from './StatusDot';

interface Props {
  title: string;
  state: NodeState;
  width?: number;
  topSlot?: ReactNode;
  children?: ReactNode;
  showLeftHandle?: boolean;
  showRightHandle?: boolean;
  className?: string;
}

export function NodeShell({
  title,
  state,
  width = 200,
  topSlot,
  children,
  showLeftHandle = true,
  showRightHandle = true,
  className
}: Props) {
  const stateLabel =
    state.kind === 'active' && state.label ? state.label : state.kind === 'active' ? 'active' : '';
  return (
    <div className="relative" style={{ width }}>
      {topSlot && <div className="absolute -top-12 left-0 right-0 flex justify-center">{topSlot}</div>}
      {showLeftHandle && <Handle type="target" position={Position.Left} isConnectable={false} className="!bg-ink-700 !border-ink-600" />}
      <div
        className={clsx(
          'rounded-xl border border-ink-800 bg-ink-900/80 backdrop-blur-sm px-4 py-3 shadow-[0_1px_0_0_var(--color-ink-800)_inset]',
          'transition-colors duration-200',
          state.kind === 'active' && 'border-ink-700',
          className
        )}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="text-[11px] uppercase tracking-[0.14em] text-ink-500">{title}</div>
          <StatusDot state={state} />
        </div>
        {stateLabel && (
          <div className="mt-1 text-xs text-ink-400 lowercase">{stateLabel}</div>
        )}
        {children && <div className="mt-3">{children}</div>}
      </div>
      {showRightHandle && <Handle type="source" position={Position.Right} isConnectable={false} className="!bg-ink-700 !border-ink-600" />}
    </div>
  );
}
